export default {
    setMedicals(state, medicals) {
        state.medicals = medicals;
    },
}